import { FadeInOnScroll } from "@/design-system/motion/FadeInOnScroll";
import { useTranslation } from "react-i18next";
import platformBranding from "@/assets/landing/white-label-branding.webp";

export function PlatformSection() {
  const { t } = useTranslation("landing");
  const steps = t("platform.steps", { returnObjects: true }) as Array<{ num: string; title: string; description: string }>;

  return (
    <section id="platform" className="py-24 md:py-32">
      <div className="max-w-5xl mx-auto px-6">
        <FadeInOnScroll>
          <p className="text-sm text-muted-foreground tracking-widest uppercase mb-4">{t("platform.badge")}</p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground max-w-2xl">
            {t("platform.headline")}
          </h2>
        </FadeInOnScroll>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="grid grid-cols-1 gap-12">
            {steps.map((step, i) => (
              <FadeInOnScroll key={step.num} delay={i * 100}>
                <div>
                  <span className="text-5xl font-bold text-muted-foreground/20">{step.num}</span>
                  <h3 className="text-lg font-semibold text-foreground mt-2">{step.title}</h3>
                  <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{step.description}</p>
                </div>
              </FadeInOnScroll>
            ))}
          </div>

          <FadeInOnScroll delay={200}>
            <div className="relative rounded-xl overflow-hidden border border-border/50 shadow-xl">
              <img
                src={platformBranding}
                alt="White-label branding configuratie"
                className="w-full h-auto"
                loading="lazy"
              />
            </div>
          </FadeInOnScroll>
        </div>
      </div>
    </section>
  );
}
